import { createMutation } from "react-query-kit";
import type { AxiosResponse } from "axios";

import type { IAppointmentDtoEndpoint } from "./types";

import { axiosClient } from "@api/clients";
import type { IApiResponse, IAxiosFn } from "@/api/types";
import { generatePath } from "@/routes/generatePath";

const createAppointment: IAxiosFn<
  IAppointmentDtoEndpoint,
  AxiosResponse<IApiResponse<{ action: string }>>
> = (data, signal) => {
  return axiosClient.post(generatePath("/appointments"), data, { signal });
};

export const useCreateAppointment = createMutation({
  mutationFn: (data: IAppointmentDtoEndpoint) => createAppointment(data),
});
